import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const inputStyle = { width: '100%', border: '2px solid #c49090', borderRadius: '8px', padding: '11px 13px', fontSize: '14px', color: '#1a1010', outline: 'none', fontFamily: 'Arial,sans-serif', background: '#fff' };
const labelStyle = { display: 'block', fontSize: '13px', fontWeight: '700', color: '#4a3030', marginBottom: '6px' };

export default function Connexion() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotMode, setForgotMode] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMsg, setForgotMsg] = useState('');

  const handleLogin = async () => {
    if (!email || !password) return setError('Veuillez remplir tous les champs.');
    setError(''); setLoading(true);
    try {
      await login(email, password);
      navigate('/profil');
    } catch (e) {
      setError(e.response?.data?.error || 'Erreur de connexion.');
    }
    setLoading(false);
  };

  const handleForgot = async () => {
    if (!forgotEmail) return setError('Entrez votre email.');
    try {
      await axios.post('/api/auth/forgot', { email: forgotEmail });
      setForgotMsg('Si cet email existe, un lien de réinitialisation a été envoyé.');
    } catch {
      setForgotMsg('Une erreur est survenue.');
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#fafaf8', display: 'grid', gridTemplateColumns: '1fr 1fr' }}>

      {/* GAUCHE */}
      <div style={{ background: 'linear-gradient(135deg,#1a1010,#2a1518)', padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '20px', right: '20px', fontSize: '120px', color: 'rgba(255,255,255,0.04)', fontFamily: 'Georgia,serif', lineHeight: 1 }}>"</div>
        <div style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#fff', marginBottom: '16px' }}>MJ <span style={{ color: '#e8a0a0' }}>—</span> Vu par ceux qui l'ont aimé</div>
        <blockquote style={{ fontFamily: 'Georgia,serif', fontSize: '18px', color: 'rgba(255,255,255,0.8)', fontStyle: 'italic', lineHeight: '1.8', borderLeft: '3px solid #8b1a2a', paddingLeft: '20px', marginBottom: '24px' }}>
          "In a world filled with hate, we must still dare to hope."
        </blockquote>
        <div style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)' }}>— Michael Jackson</div>
      </div>

      {/* DROITE */}
      <div style={{ padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ display: 'flex', gap: '0', marginBottom: '32px', border: '2px solid #8b1a2a', borderRadius: '8px', overflow: 'hidden' }}>
          <Link to="/inscription" style={{ flex: 1, padding: '10px', textAlign: 'center', fontSize: '14px', fontWeight: '700', background: '#fff', color: '#8b1a2a', textDecoration: 'none', display: 'block' }}>Créer un compte</Link>
          <div style={{ flex: 1, padding: '10px', textAlign: 'center', fontSize: '14px', fontWeight: '700', background: '#8b1a2a', color: '#fff' }}>Se connecter</div>
        </div>

        {forgotMode ? (
          <>
            <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#1a1010', marginBottom: '8px' }}>Mot de passe oublié</h2>
            <p style={{ fontSize: '13px', color: '#6a5050', marginBottom: '20px' }}>Entrez votre email et nous vous enverrons un lien de réinitialisation.</p>
            <div style={{ marginBottom: '16px' }}><label style={labelStyle}>Email</label><input style={inputStyle} type="email" placeholder="marie@email.com" value={forgotEmail} onChange={e => setForgotEmail(e.target.value)} /></div>
            {forgotMsg && <div style={{ background: '#f0fff0', border: '1px solid #80c080', borderRadius: '7px', padding: '10px 14px', fontSize: '12px', color: '#1a6a30', marginBottom: '12px' }}>{forgotMsg}</div>}
            <button onClick={handleForgot} style={{ background: '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', width: '100%', marginBottom: '12px' }}>Envoyer le lien →</button>
            <button onClick={() => setForgotMode(false)} style={{ background: 'none', border: 'none', color: '#8b1a2a', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}>← Retour à la connexion</button>
          </>
        ) : (
          <>
            <h2 style={{ fontFamily: 'Georgia,serif', fontSize: '22px', color: '#1a1010', marginBottom: '6px' }}>Bon retour ♥</h2>
            <p style={{ fontSize: '13px', color: '#6a5050', marginBottom: '24px' }}>Connectez-vous pour commenter et partager.</p>
            <div style={{ marginBottom: '16px' }}><label style={labelStyle}>Email</label><input style={inputStyle} type="email" placeholder="marie@email.com" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} /></div>
            <div style={{ marginBottom: '8px' }}><label style={labelStyle}>Mot de passe</label><input style={inputStyle} type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === 'Enter' && handleLogin()} /></div>
            <div style={{ textAlign: 'right', marginBottom: '20px' }}>
              <button onClick={() => setForgotMode(true)} style={{ background: 'none', border: 'none', color: '#8b1a2a', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Mot de passe oublié ?</button>
            </div>
            {error && <div style={{ background: '#fff0f0', border: '1px solid #e08080', borderRadius: '7px', padding: '10px 14px', fontSize: '12px', color: '#a03030', marginBottom: '12px' }}>{error}</div>}
            <button onClick={handleLogin} disabled={loading} style={{ background: loading ? '#c49090' : '#8b1a2a', color: '#fff', border: 'none', borderRadius: '8px', padding: '12px', fontSize: '14px', fontWeight: '700', cursor: loading ? 'not-allowed' : 'pointer', width: '100%' }}>
              {loading ? 'Connexion…' : '→ Se connecter'}
            </button>
            <div style={{ textAlign: 'center', fontSize: '12px', color: '#6a5050', marginTop: '16px' }}>
              Pas encore de compte ? <Link to="/inscription" style={{ color: '#8b1a2a', fontWeight: '700' }}>S'inscrire →</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
